import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { motion, AnimatePresence } from 'framer-motion';
import Pagination from '../components/Pagination';
import './AdminManagement.css';

const AdminContact = () => {
    const [contacts, setContacts] = useState([]);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const token = localStorage.getItem('adminToken');
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1
    });

    const fetchContacts = useCallback(async (page = 1) => {
        try {
            const response = await axios.get(`/api/contacts?page=${page}&limit=5`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setContacts(response.data.data);
            setPagination({
                currentPage: response.data.currentPage,
                totalPages: response.data.totalPages
            });
        } catch (err) {
            console.error('Fetch error:', err);
            setError('Failed to load inquiries.');
        }
    }, [token]);

    useEffect(() => {
        fetchContacts(1);
    }, [fetchContacts]);

    const handleDelete = async (id) => {
        if (!window.confirm('Delete this inquiry?')) return;
        setError('');
        setSuccess('');
        try {
            await axios.delete(`/api/contacts/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setSuccess('Inquiry archived/deleted successfully.');
            fetchContacts(pagination.currentPage);
            setTimeout(() => setSuccess(''), 3000);
        } catch (err) {
            setError(err.response?.data?.error || 'Delete failed.');
        }
    };

    return (
        <div className="admin-manage-page">
            <header className="manage-header">
                <h1>User Inquiries</h1>
                <p>Manage contact form submissions</p>
            </header>

            <div className="items-list-section" style={{ maxWidth: '1000px', margin: '0 auto' }}>
                <div style={{ marginBottom: '1.5rem' }}>
                    {error && <div className="login-error">{error}</div>}
                    {success && (
                        <div style={{
                            background: 'rgba(16, 185, 129, 0.1)',
                            border: '1px solid rgba(16, 185, 129, 0.2)',
                            color: '#6ee7b7',
                            padding: '1rem',
                            borderRadius: '12px',
                            textAlign: 'center',
                            fontSize: '0.9rem'
                        }}>
                            {success}
                        </div>
                    )}
                </div>

                <AnimatePresence>
                    {contacts.map((c) => (
                        <motion.div
                            key={c._id}
                            className="item-row-card"
                            style={{ padding: '2rem', marginBottom: '1.5rem', display: 'block' }}
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0, scale: 0.95 }}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
                                <div className="contact-meta">
                                    <h4 style={{ fontSize: '1.3rem', color: '#fff' }}>{c.subject}</h4>
                                    <p style={{ color: '#818cf8', fontWeight: '500' }}>From: {c.name} ({c.email})</p>
                                    <p style={{ fontSize: '0.8rem', opacity: 0.6 }}>{new Date(c.createdAt).toLocaleString()}</p>
                                </div>
                                <div className="item-actions">
                                    <button onClick={() => handleDelete(c._id)} className="delete-btn">Archive / Delete</button>
                                </div>
                            </div>
                            <div style={{ background: 'rgba(255,255,255,0.03)', padding: '1.5rem', borderRadius: '12px' }}>
                                <p style={{ whiteSpace: 'pre-wrap', lineHeight: '1.6', color: 'rgba(255,255,255,0.8)' }}>{c.message}</p>
                            </div>
                        </motion.div>
                    ))}
                    {contacts.length === 0 && <p style={{ textAlign: 'center', opacity: 0.5 }}>No inquiries found.</p>}
                </AnimatePresence>

                <Pagination
                    currentPage={pagination.currentPage}
                    totalPages={pagination.totalPages}
                    onPageChange={fetchContacts}
                />
            </div>
        </div>
    );
};

export default AdminContact;
